import { object, string } from "yup";

export const addFilingManualBankSchema = object({
  name: string().required("Please enter bank name"),
  account_number: string().required("Please enter account number"),
  routing_number: string()
    .required("Please enter routing number")
    .matches(/^.{9}$/, "Routing number must be exactly 9 characters"),
  address: string().required("Please add an address"),
});
